import logger from '../utils/logger';
import api from '../config/api';

const planService = {
  async getPublicPlans() {
    try {
      const response = await api.get('/billing/plans/public');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Failed to fetch public plans:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch plans'
      };
    }
  }
};

export default planService;
